export default {
  buttonContrastColor: Styles.color.primary,
  points: 'crownPoints',
};
